export const userStatusColor = (status: string | null) => {
    if (status === null || status === undefined) return "bg-S2D-neutral-70";

    if (status === "Active" || status === "Live") {
        return "bg-S2D-success-80";
    } else {
        return "bg-S2D-warning-90";
    }
};
